export const {
  REACT_APP_API_BASE_URL,
  REACT_APP_CLERK_API_URL,
  REACT_APP_MAPBOX_ACCESS_TOKEN,
  // eslint-disable-next-line no-undef
} = process.env;
